import { UserAvatar } from "@wrstudios/components";
import { getFirstName, getInitials } from "@wrstudios/utils";
import PropTypes from "prop-types";
import React from "react";
import { useLive } from "../LiveProvider";
import {
  AgentNoteContent,
  AgentNoteContentWrapper,
  AgentNoteTitle,
  AgentNoteWrapper,
  AvatarWrapper
} from "./styled/agent-note";

export default function AgentNote({ anchor, note }) {
  const { agent } = useLive();

  if (!note) return null;

  return (
    <AgentNoteWrapper anchor={anchor}>
      <AvatarWrapper>
        <UserAvatar
          initials={getInitials(agent.name)}
          avatarUrl={agent.avatarUrl}
        />
      </AvatarWrapper>
      <AgentNoteContentWrapper>
        <AgentNoteTitle>Note from {getFirstName(agent.name)}:</AgentNoteTitle>
        <AgentNoteContent>{note}</AgentNoteContent>
      </AgentNoteContentWrapper>
    </AgentNoteWrapper>
  );
}

AgentNote.defaultProps = {
  anchor: "center"
};

AgentNote.propTypes = {
  note: PropTypes.string,
  anchor: PropTypes.oneOf(["left", "center", "top", "right", "bottom"])
};
